/**
 * @function filterContacts
 * @param {string} value
 * @param {Contact[]} contacts
 * @returns {Contact[]}
 */
function filterContacts(value, contacts) {
	if (value === '') return;

	const filtered = contacts.filter((contact) => {
		return (
			contact.firstName.toLowerCase().includes(value?.toLowerCase()) ||
			contact.lastName.toLowerCase().includes(value?.toLowerCase())
		);
	});

	return filtered;
}

export default filterContacts;
